import { createCustomFilterForEntity } from "@shared/backend/create-custom-filter-for-entity";
import {
  filterWithRelationsAndJson,
  type RelationalOrJsonEntityFilter,
} from "@shared/helpers/sql-relations";
import { PartnerOrganizationLead } from "./entity";

const createCustomFilter =
  createCustomFilterForEntity<PartnerOrganizationLead>();

export class PartnerOrganizationLeadFilters {
  static hyperFilter = createCustomFilter<
    RelationalOrJsonEntityFilter<PartnerOrganizationLead>
  >((filters) =>
    filterWithRelationsAndJson(PartnerOrganizationLead)(filters),
  );
}
